import { render, staticRenderFns } from "./modalcomponent.vue?vue&type=template&id=33775162&scoped=true&"
import script from "./modalcomponent.vue?vue&type=script&lang=js&"
export * from "./modalcomponent.vue?vue&type=script&lang=js&"
import style0 from "./modalcomponent.vue?vue&type=style&index=0&id=33775162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33775162",
  null
  
)

export default component.exports